<template>
  <div>
    <cta-banner :title="$route.name"/>

    <section class="container mx-auto" v-if="plantillasFiltradas.length > 0">
      <div class="w-full pt-12">
        <h2 class="text-3xl font-bold mb-7 title relative">Plantillas presentaciones y poster</h2>
      </div>
      <div class="container px-5 pb-16 mx-auto">
        <div class="flex flex-wrap -m-4">
          <div class="p-4 lg:w-1/2 md:w-full" v-for="plantilla in plantillasFiltradas" :key="plantilla.nombre">
            <div class="flex border-2 rounded-lg border-gray-200 border-opacity-50 p-8 sm:flex-row flex-col">
              <div class="w-16 h-16 sm:mr-8 sm:mb-0 mb-4 inline-flex items-center justify-center rounded-full bg-gray-100 text-gray-400 flex-shrink-0">
                <FileDocumentOutline :size="30" />
              </div>

              <div v-if="plantilla.nombre !== 'LaTeX template in OverLeaf'">
                <div class="flex-grow">
                  <h2 class="text-gray-900 text-lg title-font font-medium mb-3 tracking-tight">{{plantilla.nombre}}</h2>
                  <p class="leading-relaxed text-base">{{plantilla.descripcion}}</p>
                  <span class="px-6 py-2 mt-5 inline-flex items-center text-xs leading-5 font-semibold rounded-full bg-red-100 text-theme-color p-1">
                    <ArrowCollapseDown :size="18" />
                    <a :href="plantilla.documento.replace('http://', 'https://')" target="_blank" :download="plantilla.nombre" class="pl-2">
                      Descargar plantilla</a>
                  </span>
                </div>
              </div>

              <div v-else>
                <div class="flex-grow">
                  <h2 class="text-gray-900 text-lg title-font font-medium mb-3 tracking-tight">{{plantilla.nombre}}</h2>
                  <p class="leading-relaxed text-base">{{plantilla.nombre}}</p>
                  <span class="px-6 py-2 mt-5 inline-flex items-center text-xs leading-5 font-semibold rounded-full bg-red-100 text-theme-color p-1">
                    <ArrowCollapseDown :size="18" />
                    <a :href="plantilla.descripcion.replace('http://', 'https://')" target="_blank" :download="plantilla.nombre" class="pl-2">
                      Descargar plantilla</a>
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container mx-auto" :class="plantillasFiltradas.length > 0 ? 'pb-28' : 'py-28'" v-if="trabajos.length > 0">
      <cta-description :class="plantillasFiltradas.length > 0 ? '' : 'md:pt-28'" v-if="header.titulo" :descripcion="header" :patrocinar="true" />
      <cta-table :memorias="trabajos" :isButton="false" :isAutores="true" />
    </section>
  </div>
</template>

<script>
import CtaBanner from '../../components/common/CtaBanner.vue';
import CtaTable from '../../components/CtaTable.vue';
import CtaDescription from '../../components/CtaDescription.vue';
import ArrowCollapseDown from 'vue-material-design-icons/ArrowCollapseDown.vue';
import FileDocumentOutline from 'vue-material-design-icons/FileDocumentOutline.vue';
import API from "@/api";
import {mapState} from "vuex";

export default {
  name: "Trabajos",
  components: {
    CtaBanner,
    CtaTable,
    CtaDescription,
    ArrowCollapseDown,
    FileDocumentOutline
  },
  data() {
    return {
      trabajos: [],
      plantillas: [],
      header: {}
    };
  },
  computed: {
    ...mapState(["idEventoActual"]),
    plantillasFiltradas() {
      return this.plantillas.filter((plantilla) =>
        /oral|poster/i.test(plantilla.nombre)
      );
    },
  },
  created() {
    this.getTrabajos();
    this.getPlantillas();
    this.getInfo();
  },
  methods: {
    async getPlantillas() {
      const params = {
        "evento_fk" : this.idEventoActual,
        format:  "json",
      };
      const { data } = await API.getPlantillas(params);
      this.plantillas = data.results;
    },
    async getTrabajos() {
      let { data } = await API.getTrabajos({ evento_fk: this.idEventoActual });
      let results = data.results;
      // Se reutiliza API.getTrabajos (https) en vez de seguir "next" tal cual,
      // porque la API a veces lo devuelve como http:// y el navegador bloquea
      // esa URL por CORS al redirigir a https.
      while (data.next) {
        const nextParams = Object.fromEntries(new URL(data.next).searchParams);
        ({ data } = await API.getTrabajos(nextParams));
        results = results.concat(data.results);
      }
      this.trabajos = results;
    },
    async getInfo() {
      const params = {
        "evento_fk" : this.idEventoActual,
        format:  "json"
      };
      const { data } = await API.getInfo(params);
      let items = data.results;
      for (let i in items){
        this.header = (items[i].codigo === 'AU04') ? items[i] : this.header;
      }
    }
  },
}
</script>

<style scoped>
  .title::before{
    content: '';
    position: absolute;
    width: 3rem;
    top: -15px;
    border-radius: 20px;
    border: 2px solid var(--theme-color);
  }
</style>
